export const initialState = {
  isLoading: false,
  reservation: null,
};

export function init(state) {
  return state;
}

export function reducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case 'toggleLoading': {
      return { ...state, isLoading: !state.isLoading };
    }
    case 'updateReservation': {
      return { ...state, reservation: payload };
    }
    default: {
      throw new Error();
    }
  }
}
